// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3nxHg","emails":"CreateEditClinics_emails__2Xl4H","emailTagLabel":"CreateEditClinics_emailTagLabel__3hjjr"};